<template>
  <div>
    <MainForm
      :name="FORM_NAMES.leadCapture"
      :show-step="isOnStep"
      :logic-callbacks="getLogicCallback"
      :ui-form="uiForm"
      :end-page-data="endPageData"
      :ui-modal-and-end-page="uiModalAndEndPage"
      ui-title="Striver card application"
    >
      <StepModel
        :ui="uiBasePersonal"
        :name="STEP_NAMES.welcome"
        ui-title="Contact Information"
        ui-subtitle="We need to ask you a few questions to create your profile"
        ui-error-message="Please review the fields marked in red"
        ui-button-text="Submit"
      >
        <FieldsetFullName :fieldset-name="FIELDSET_NAMES.fullNameReview" />
        <FieldsetEmail />
        <FieldsetMobilePhone title="Your mobile number is" />
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.fixedIncomeFieldset"
          ui-title="What is your fixed monthly income?"
        >
          <FieldIncome
            :name="FIELD_NAMES.fixedIncome"
            label="Enter your monthly income in AED"
          />
        </FieldsetModel>
      </StepModel>
    


    </MainForm>
  </div>
</template>
<script>
import MainForm from "@/lib/components/main-form";
import StepModel from "@/lib/components/models/step";
import FieldsetModel from "@/lib/components/models/fieldset";
import STEP_NAMES from "@/forms/constants/step-names";
// Ui Wrappers
import UiWrapper from "@/forms/components/base/ui-wrapper";

import FieldIncome from "@/forms/components/shared/fields/income";
import FieldsetVariableIncome from "@/forms/components/shared/fields/variable-income";

// Ui Components
import {
  InputText,
  InputSlide,
  Choice,
  Suggest,
  Dropdown,
  InputPassword,
  Expandable,
  Button,
} from "@dunia/ui";

// Utils
import CheckWrapper from "@/forms/components/ui-dunia/check-wrapper";
import getLastEditValue from "@/forms/helpers/get-last-edit-value";
import FormComponentMixin from "@/lib/mixins/form-component-mixin";
import Vue from "vue";
import * as conditions from "@/forms/conditions";
// Services

import formService from "@/forms/api/services/form";
import flowManager from "@/lib/services/flow-manager";

// Constants
import { MIN_FIXED_INCOME } from "@/forms/constants/onboarding-logic";
import FIELD_NAMES from "@/forms/constants/field-names";

import StepPersonalInfo from "@/forms/components/cards/stp-card/steps/personal-information";
import FieldsetEmail from "@/forms/components/shared/fieldsets/email";
import FieldsetBornDate from "@/forms/components/shared/fieldsets/born-date";
import FieldsetMobilePhone from "@/forms/components/shared/fieldsets/mobile-phone";
import FieldsetIBAN from "@/forms/components/shared/fieldsets/iban-number";
import FieldsetFullName from "@/forms/components/shared/fieldsets/full-name";

import getValueByFieldName from "@/forms/helpers/get-value-by-field-name";
import DateWrapper from "@/forms/components/ui-dunia/date-wrapper";


import { parse } from "path";
//Store
import store from "@/store";
import { type } from "os";
import { watch } from "fs";

export default {
  name: "OnboardDunia",
  mixins: [FormComponentMixin],
  components: {
    //Components
    MainForm,
    StepModel,
    FieldsetModel,
    Dropdown,
    Choice,
    Suggest,
    InputText,
    InputSlide,
    UiWrapper,
    StepPersonalInfo,
    FieldsetEmail,
    FieldsetBornDate,
    FieldsetMobilePhone,
    FieldsetFullName,
    FieldIncome,
    FieldsetVariableIncome,
    InputPassword,
    CheckWrapper,
    Expandable,
    Button,
    DateWrapper,
   
  },

  data: () => ({
    
   
  }),
 mounted() {
    //getGoogleTagManager();
    var gtagID = process.env.VUE_APP_GA_MEASUREMENT_ID;
    if (gtagID) {
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", `${gtagID}`);
    }
  },
  updated: function () {
   
  },

  computed: {
    
  },
  methods: {
    finishCallback() {
      //if (!this.$store.state.offerRejected) {
     
      var  titleMessage = `Thank you for your application.`;
      var  subtitleMessage = `Our team will get back to you shortly.`;
            this.showEndPage({
        title: titleMessage,
        subtitle: subtitleMessage,
        //actionNameEndForm: "Thanks"
      });
    },
  },

};
</script>

<style  scoped>
@keyframes blink {
  /**
     * At the start of the animation the dot
     * has an opacity of .2
     */
  0% {
    opacity: 0.2;
  }
  /**
     * At 20% the dot is fully visible and
     * then fades out slowly
     */
  20% {
    opacity: 1;
  }
  /**
     * Until it reaches an opacity of .2 and
     * the animation can start again
     */
  100% {
    opacity: 0.2;
  }
}

.saving .dotAnimation {
  /**
     * Use the blink animation, which is defined above
     */
  animation-name: blink;
  /**
     * The animation should take 1.4 seconds
     */
  animation-duration: 0.5s;
  /**
     * It will repeat itself forever
     */
  animation-iteration-count: infinite;
  /**
     * This makes sure that the starting style (opacity: .2)
     * of the animation is applied before the animation starts.
     * Otherwise we would see a short flash or would have
     * to set the default styling of the dots to the same
     * as the animation. Same applies for the ending styles.
     */

  animation-fill-mode: both;
}

.dot {
  animation-name: blink;
  /**
     * The animation should take 1.4 seconds
     */
  animation-duration: 0.5s;
  /**
     * It will repeat itself forever
     */
  animation-iteration-count: infinite;
  height: 8px;
  width: 8px;
  background-color: #000000;
  border-radius: 50%;
  display: inline-block;
  margin-right: 15px;
}
.dotText {
  font-family: "Moderat", serif;
  font-weight: 300;
  font-size: 15px;
  color: #9e9e9e;
}
/* #promoButton:hover {
  text-decoration: underline;
} */

</style>
